import { PgReader } from "./pgreader";

export class PrintService {
  public static instance: PrintService = new PrintService()

  private printQuery: HTMLStyleElement
  private printContainer: HTMLDivElement
  private checkPrintQuery() {
    if (!this.printQuery) {
      let style = this.printQuery = document.createElement('style')
      style.textContent = `@media print { .pagebreak { page-break-before: always; }}`
      document.head.appendChild(style)
    }
  }

  beforePrint(reader: PgReader) {
    this.checkPrintQuery()
    if (this.printContainer) this.printContainer.remove()

    let printContainer = this.printContainer = document.createElement('div')

    reader.printPages(printContainer, 0, -1, () => {
      let root = document.getElementById('root')
      root.style.display = 'none'
      document.body.appendChild(printContainer)
      //no need, browser will callthis. window.print()

    })
  }
  
  afterPrint(reader: PgReader) {
    if (this.printContainer) this.printContainer.remove()
    let root = document.getElementById('root')
    root.style.display = 'block'

  }
}